import styled from '@emotion/styled';

const Container = styled.div<{ chosen: boolean }>(({ chosen }) => ({
  margin: '5px 0',
  borderRadius: '4px',
  padding: '10px',
  boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)',
  display: 'grid',
  alignItems: 'center',
  background: `rgba(93, 223, 171, ${chosen ? 0.2 : 0})`,
  '&:hover': {
    cursor: 'pointer',
    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)',
    transform: 'translate(-3px, -3px)',
    transition: 'all 0.2s ease-in-out',
  },
}));

const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: flex-start;
  flex-grow: 1;
  justify-content: space-between;
`;

const Arrow = styled.button<{ open: boolean }>((props) => ({
  background: 'none',
  border: 'none',
  width: '25px',
  height: '25px',
  padding: '0',
  borderRadius: '50%',
  transform: `rotate(${props.open ? '0deg' : '-180deg'})`,
  transition: 'all 0.2s ease-in-out',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  justifySelf: 'center',
  ':hover': {
    cursor: 'pointer',
    background: '#eee',
  },
}));

export { Container, Info, Arrow };
